import * as React from 'react'
import { DataGrid } from '@mui/x-data-grid'
import { Box, CircularProgress, Typography } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import DeleteOutlineSharpIcon from '@mui/icons-material/DeleteOutlineSharp'
import IconButton from '@mui/material/IconButton'
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined'
import RemoveCircleOutlineSharpIcon from '@mui/icons-material/RemoveCircleOutlineSharp'
import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import nodatafound from '../../utilities/dummy_assets/nodatafound.jpg'
import { ImageBaseURL } from '../../utilities/api/axios'
import InventoryListAPIs from '../../utilities/api/inventory/AdminInventoryList'
import InventoryDetailAPIs from '../../utilities/api/inventory/AdminInventoryDetail'
import Delete from './Popups/Delete'
import EditInventoryDialog from './Popups/EditInventory'
import AddStock from './Popups/AddStock'
import RemoveStock from './Popups/RemoveStock'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import CustomPagination from '../CustomPagination/CustomPagination'
import TuneIcon from '@mui/icons-material/Tune'

const InventoryTable = ({
  searchQuery,
  category,
  group,
  tag,
  update,
  setUpdate,
  flag,
  setFlag
}) => {
  const user = useSelector((state) => state.user.user)
  const token = user.access

  const [tableData, setTableData] = useState([])
  const [loading, setLoading] = useState(true)
  const [page, setPage] = useState(0)
  const [openDeletePopup, setOpenDeletePopup] = useState(false)
  const [currentRow, setCurrentRow] = useState(null)
  const [isEditInventoryOpen, setEditInventoryOpen] = useState(false)
  const [openAddStockPopup, setopenAddStockPopup] = useState(false)
  const [openRemoveStockPopup, setopenRemoveStockPopup] = useState(false)

  useEffect(() => {
    setLoading(true)
    const response = InventoryListAPIs.InventoryListGet(token)
    response
      .then((result) => {
        setTableData(result)
      })
      .catch((error) => {
        toast.error('Error fetching inventory data')
      })
      .finally(() => {
        setLoading(false)
      })
  }, [update, user])

  const rows = tableData.map((item, index) => ({ ...item, index }))

  const handleEditInventory = (row) => {
    setCurrentRow(row)
    setEditInventoryOpen(true)
  }

  const handleOpenDeletePopup = (row) => {
    setCurrentRow(row)
    setOpenDeletePopup(true)
  }

  const handleOpenAddStockPopup = (row) => {
    setCurrentRow(row)
    setopenAddStockPopup(true)
  }

  const handleOpenRemoveStockPopup = (row) => {
    setCurrentRow(row)
    setopenRemoveStockPopup(true)
  }

  // The missing functions that need to be defined
  const handleCloseAddStockPopup = () => {
    setopenAddStockPopup(false)
  }

  const handleCloseRemoveStockPopup = () => {
    setopenRemoveStockPopup(false)
  }

  const handleCloseDeletePopup = () => {
    setOpenDeletePopup(false)
  }

  const handleDelete = () => {
    const response = InventoryDetailAPIs.InventoryDetailDelete(currentRow.id, token)
    response
      .then(() => {
        setUpdate((prev) => !prev)
        toast.success('Item successfully deleted')
      })
      .catch((error) => {
        toast.error('Error deleting item')
      })
    setOpenDeletePopup(false)
  }

  const filteredRows = rows.filter((row) => {
    const lowercasedSearchQuery = searchQuery.toLowerCase()
    return row.name && row.name.toLowerCase().includes(lowercasedSearchQuery)
  })

  const columns = [
    {
      field: 'name',
      headerName: 'Inventory Name',
      width: 250,
      headerAlign: 'left',
      headerClassName: 'header-style',
      renderCell: (params) => {
        const imageUrl =
          params.row && params.row.image ? `${ImageBaseURL}${params.row.image}` : nodatafound
        const text = params.row && params.row.name ? params.row.name : 'No Text'
        const subtext = params.row && params.row.upc ? params.row.upc : 'No Subtext'
        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 1
            }}
          >
            <img
              src={imageUrl}
              alt={params.row.name}
              style={{ width: '50px', height: '50px', borderRadius: '50%' }}
            />
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Typography variant="subtitle2" sx={{ color: '#434343' }}>
                {text}
              </Typography>
              <Typography variant="body2" sx={{ color: '#8C8C8C' }}>
                {subtext}
              </Typography>
            </Box>
          </Box>
        )
      }
    },
    {
      field: 'group',
      headerName: 'Group',
      width: 100,
      headerAlign: 'left',
      align: 'left',
      headerClassName: 'header-style',
      renderCell: (params) => (
        <Typography sx={{ color: '#434343', textAlign: 'left', width: '100%' }}>
          {params.row.group || '-'}
        </Typography>
      )
    },
    {
      field: 'category',
      headerName: 'Category',
      width: 150,
      headerAlign: 'left',
      align: 'left',
      headerClassName: 'header-style',
      renderCell: (params) => (
        <Box sx={{ border: '1px solid #E6E6E6', borderRadius: '50px', padding: '4px 8px' }}>
          <Typography sx={{ color: '#8C8C8C', textAlign: 'left', width: '100%' }}>
            {params.row.category}
          </Typography>
        </Box>
      )
    },
    {
      field: 'manufacturer',
      headerName: 'Manufacturer',
      width: 150,
      headerAlign: 'left',
      headerClassName: 'header-style',
      renderCell: (params) => (
        <Typography sx={{ color: '#434343', textAlign: 'left', width: '100%' }}>
          {params.row.manufacturer}
        </Typography>
      )
    },
    {
      field: 'location',
      headerName: 'Location',
      width: 150,
      headerAlign: 'left',
      headerClassName: 'header-style',
      renderCell: (params) => (
        <Typography
          sx={{
            color: '#434343',
            textAlign: 'left',
            width: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
          title={params.row.location || '-'}
        >
          {params.row.location || '-'}
        </Typography>
      )
    },
    {
      field: 'availability',
      headerName: 'Availability',
      width: 130,
      headerAlign: 'left',
      align: 'left',
      headerClassName: 'header-style',
      renderCell: (params) => {
        const availabilityList = ['Moderate', 'Very Low', 'Low', 'High', 'Always']
        let availabilityValue = '-'

        // Handle both numeric (0-4) and text values
        if (
          params.row.availability !== undefined &&
          params.row.availability !== null &&
          params.row.availability !== ''
        ) {
          if (typeof params.row.availability === 'number') {
            availabilityValue = availabilityList[params.row.availability] || '-'
          } else {
            availabilityValue = params.row.availability
          }
        }

        return (
          <Typography sx={{ color: '#434343', textAlign: 'left', width: '100%' }}>
            {availabilityValue}
          </Typography>
        )
      }
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 150,
      headerAlign: 'left',
      align: 'left',
      headerClassName: 'header-style',
      renderCell: (params) => {
        const statusList = ['Operational', 'Under Maintenance', 'Out of Service']
        let statusValue = '-'

        // Handle both numeric (0-2) and text values
        if (
          params.row.status !== undefined &&
          params.row.status !== null &&
          params.row.status !== ''
        ) {
          if (typeof params.row.status === 'number') {
            statusValue = statusList[params.row.status] || '-'
          } else {
            statusValue = params.row.status
          }
        }

        return (
          <Typography sx={{ color: '#434343', textAlign: 'left', width: '100%' }}>
            {statusValue}
          </Typography>
        )
      }
    },
    {
      field: 'supervised',
      headerName: 'Supervised',
      width: 110,
      headerAlign: 'left',
      align: 'left',
      headerClassName: 'header-style',
      renderCell: (params) => (
        <Typography sx={{ color: '#434343', textAlign: 'left', width: '100%' }}>
          {params.row.supervised ? 'Yes' : 'No'}
        </Typography>
      )
    },
    {
      field: 'description',
      headerName: 'Description',
      width: 300,
      headerAlign: 'left',
      align: 'left',
      headerClassName: 'header-style',
      renderCell: (params) => (
        <Typography
          sx={{
            color: '#434343',
            textAlign: 'left',
            width: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
          title={params.row.description || '-'}
        >
          {params.row.description}
        </Typography>
      )
    },
    {
      field: 'stock_available',
      headerName: 'Stock',
      width: 100,
      headerAlign: 'left',
      align: 'left',
      headerClassName: 'header-style',
      renderCell: (params) => (
        <Typography sx={{ color: '#434343', textAlign: 'left', width: '100%' }}>
          {params.row.stock_available}{' '}
          {params.row.stock_unit !== 'number' ? params.row.stock_unit : ''}
        </Typography>
      )
    },
    {
      field: 'stock_total',
      headerName: 'Total Stock',
      width: 100,
      headerAlign: 'left',
      align: 'left',
      headerClassName: 'header-style',
      renderCell: (params) => (
        <Typography sx={{ color: '#434343', textAlign: 'left', width: '100%' }}>
          {params.row.stock_total || 0}{' '}
          {params.row.stock_total !== 'number' ? params.row.stock_unit : ''}
        </Typography>
      )
    },
    {
      field: 'editstock',
      headerName: 'Edit stock',
      sortable: false,
      width: 100,
      headerAlign: 'left',
      align: 'left',
      headerClassName: 'header-style',
      renderCell: (params) => (
        <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <IconButton aria-label="add" onClick={() => handleOpenAddStockPopup(params.row)}>
            <AddCircleOutlineOutlinedIcon sx={{ color: 'green' }} />
          </IconButton>
          <IconButton aria-label="remove" onClick={() => handleOpenRemoveStockPopup(params.row)}>
            <RemoveCircleOutlineSharpIcon sx={{ color: '#C90505' }} />
          </IconButton>
        </Box>
      )
    },
    {
      field: 'action',
      headerName: 'Action',
      sortable: false,
      width: 100,
      headerAlign: 'left',
      align: 'left',
      headerClassName: 'header-style',
      renderCell: (params) => (
        <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <IconButton aria-label="edit" onClick={() => handleEditInventory(params.row)}>
            <EditIcon />
          </IconButton>
          <IconButton aria-label="delete" onClick={() => handleOpenDeletePopup(params.row)}>
            <DeleteOutlineSharpIcon sx={{ color: '#C90505' }} />
          </IconButton>
        </Box>
      )
    }
  ]

  return (
    <Box
      sx={{
        height: '480px',
        width: '100%',
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        padding: '16px',
        boxSizing: 'border-box'
      }}
    >
      {loading ? (
        <Box
          sx={{
            display: 'flex',
            marginTop: '100px',
            padding: '32px 24px',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '21px'
          }}
        >
          <CircularProgress />
          <Typography
            sx={{
              color: '#273F77',
              textAlign: 'center',
              fontFamily: 'Inter',
              fontSize: 26,
              fontWeight: 500,
              lineHeight: '150%',
              letterSpacing: '-0.352px'
            }}
          >
            Loading...
          </Typography>
        </Box>
      ) : filteredRows.length > 0 ? (
        <Box
          sx={{
            width: '100%',
            overflowX: 'auto'
          }}
        >
          <DataGrid
            rows={filteredRows}
            rowHeight={85}
            columns={columns}
            pagination
            pageSizeOptions={[7, 10, 25]}
            initialState={{
              pagination: { paginationModel: { pageSize: 7 } }
            }}
            paginationMode="client"
            slots={{
              pagination: CustomPagination,
              columnMenuIcon: () => (
                <TuneIcon
                  sx={{
                    transform: 'rotate(90deg)',
                    fill: '#8C8C8C',
                    height: '20px',
                    width: '18px'
                  }}
                />
              )
            }}
            // disableSelectionOnClick
            // disableColumnFilter
            // disableColumnMenu
            disableDensitySelector
            sx={{
              '& .MuiDataGrid-root': {
                border: 'none'
              },
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: '#f5f5f5',
                color: '#3f3f3f',
                fontWeight: 'bold',
                fontSize: '16px',
                textAlign: 'left'
              },
              '& .MuiDataGrid-columnHeader': {
                borderRight: '1px solid #E6E6E6',
                '&:last-child': {
                  borderRight: 'none'
                }
              },
              '& .MuiDataGrid-cell': {
                textAlign: 'left',
                color: '#3f3f3f',
                borderRight: '1px solid #E6E6E6',
                '&:last-child': {
                  borderRight: 'none'
                }
              },
              '& .MuiDataGrid-footerContainer': {
                justifyContent: 'center',
                alignItems: 'center',
                '& .MuiTablePagination-root': {
                  textAlign: 'center',
                  '& .MuiButtonBase-root': {
                    color: '#3f3f3f'
                  }
                }
              },
              '& .MuiPaginationItem-root': {
                color: '#3f3f3f'
              },
              '& .MuiDataGrid-selectedRowCount': {
                visibility: 'hidden',
                width: 0,
                padding: 0,
                margin: 0,
                flex: '0 !important'
              },
              '& .MuiDataGrid-footerContainer': {
                paddingTop: '4px',
                paddingBottom: '4px',
                justifyContent: 'center',
                borderTop: 'none'
              }
            }}
          />
        </Box>
      ) : (
        <Box sx={{ textAlign: 'center', padding: 4 }}>
          <img
            src={nodatafound}
            alt="No data found"
            style={{ width: '350px', marginBottom: '16px' }}
          />
          <Typography variant="h6">No Data Found</Typography>
        </Box>
      )}
      <AddStock
        currentRow={currentRow}
        open={openAddStockPopup}
        onClose={handleCloseAddStockPopup}
        update={update}
        setUpdate={setUpdate}
      />
      <RemoveStock
        currentRow={currentRow}
        open={openRemoveStockPopup}
        onClose={handleCloseRemoveStockPopup}
        update={update}
        setUpdate={setUpdate}
      />
      <Delete
        currentRow={currentRow}
        open={openDeletePopup}
        onClose={handleCloseDeletePopup}
        onConfirm={handleDelete}
      />
      <EditInventoryDialog
        currentRow={currentRow}
        open={isEditInventoryOpen}
        onClose={() => setEditInventoryOpen(false)}
        update={update}
        setUpdate={setUpdate}
        flag={flag}
        setFlag={setFlag}
      />
      <ToastContainer />
    </Box>
  )
}

export default InventoryTable
